import { render, staticRenderFns } from "./PicklDetails.vue?vue&type=template&id=27278c3c&scoped=true&"
import script from "./PicklDetails.vue?vue&type=script&lang=js&"
export * from "./PicklDetails.vue?vue&type=script&lang=js&"
import style0 from "./PicklDetails.vue?vue&type=style&index=0&id=27278c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27278c3c",
  null
  
)

export default component.exports